/**
 * @generated SignedSource<<bac031751b5e8d4787a90e5f4c215550>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ResultFilter = {
  matchAny?: boolean | null | undefined;
  metaKey: string;
  metaValues: ReadonlyArray<string>;
};
export type MetaResultsLoaderQuery$variables = {
  filters?: ReadonlyArray<ResultFilter> | null | undefined;
  questionnaireId: string;
};
export type MetaResultsLoaderQuery$data = {
  readonly metaResults: ReadonlyArray<{
    readonly metaKey: string | null | undefined;
    readonly metaValue: string | null | undefined;
    readonly responseCount: number | null | undefined;
  }>;
};
export type MetaResultsLoaderQuery = {
  response: MetaResultsLoaderQuery$data;
  variables: MetaResultsLoaderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "questionnaireId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "filters"
  },
  {
    "kind": "Variable",
    "name": "questionnaireId",
    "variableName": "questionnaireId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "metaKey",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "metaValue",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "responseCount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MetaResultsLoaderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "MetaResult",
        "kind": "LinkedField",
        "name": "metaResults",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "MetaResultsLoaderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "MetaResult",
        "kind": "LinkedField",
        "name": "metaResults",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e84220eff869805938808bfadc9df24a",
    "id": null,
    "metadata": {},
    "name": "MetaResultsLoaderQuery",
    "operationKind": "query",
    "text": "query MetaResultsLoaderQuery(\n  $questionnaireId: ID!\n  $filters: [ResultFilter!]\n) {\n  metaResults(questionnaireId: $questionnaireId, filters: $filters) {\n    metaKey\n    metaValue\n    responseCount\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "49c1ec61e73ff277a457534862b7dbb7";

export default node;
